import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DlmStatus } from 'views/DraftMode/DraftSwitch';

export interface DlmState {
  dlmStatus: DlmStatus | undefined;
  dlmVersion: number | undefined;
  targetDlmStatus: DlmStatus | undefined;
  targetDlmVersion: number | undefined;
}

export const initialDlmState: DlmState = {
  dlmStatus: undefined,
  dlmVersion: undefined,
  targetDlmStatus: undefined,
  targetDlmVersion: undefined,
};

const dlmSlice = createSlice({
  name: 'DLM',
  initialState: initialDlmState,
  reducers: {
    setDlmStatus: (state, action: PayloadAction<DlmStatus>) => {
      return { ...state, dlmStatus: action.payload, targetDlmStatus: action.payload };
    },
    setDlmVersion: (state, action: PayloadAction<number | undefined>) => {
      return { ...state, dlmVersion: action.payload };
    },
    setTargetDlmStatus: (state, action: PayloadAction<DlmStatus>) => {
      return { ...state, targetDlmStatus: action.payload };
    },
    setTargetDlmVersion: (state, action: PayloadAction<number | undefined>) => {
      return { ...state, targetDlmVersion: action.payload };
    },
    setDlmStatusAndVersion: (state, action: PayloadAction<{ status: DlmStatus; version: number | undefined }>) => {
      return {
        ...state,
        dlmStatus: action.payload.status,
        // targetDlmStatus: action.payload.status,
        dlmVersion: action.payload.version,
      };
    },
    setTargetDlmStatusAndVersion: (
      state,
      action: PayloadAction<{ status: DlmStatus; version: number | undefined }>,
    ) => {
      return {
        ...state,
        targetDlmStatus: action.payload.status,
        targetDlmVersion: action.payload.version,
      };
    },
    resetDlmState: (state) => {
      return {
        ...state,
        dlmStatus: undefined,
        dlmVersion: undefined,
        targetDlmStatus: undefined,
        targetDlmVersion: undefined,
      };
    },
  },
});

export const {
  setDlmStatus,
  setDlmVersion,
  setTargetDlmStatus,
  setDlmStatusAndVersion,
  resetDlmState,
  setTargetDlmStatusAndVersion,
} = dlmSlice.actions;

export default dlmSlice.reducer;
